import React from "react";

import styles from "./counter.scss";

const Counter = ({ total, currentIndex }) => (
  <div className={styles.counter}> {`${currentIndex}/${total}`}</div>
);

export default Counter;



// WEBPACK FOOTER //
// ./src/components/IndexCarousel/Counter/index.tsx